import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { Stack, Typography } from "@mui/material"

import { colors } from "../../../utils/theme"

interface ChartAlertProps {
  association: "positive" | "negative"
  variant: "increasing" | "decreasing"
  changeAmount: number
  message: string
}

/**
 * Trend delta pill under mood charts. Surfaces follow ambient light/dark theme.
 */
export default function ChartAlert({
  association,
  variant,
  changeAmount,
  message,
}: ChartAlertProps) {
  const icon = variant === "increasing" ? faArrowUp : faArrowDown
  const toneColor =
    association === "positive"
      ? colors.graphs.alerts.positive
      : colors.graphs.alerts.negative

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.25}
      sx={(theme) => ({
        display: "inline-flex",
        px: 2,
        py: 1.25,
        border: `1px solid ${
          theme.palette.vira?.border ?? theme.palette.divider
        }`,
        borderRadius: 999,
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.vira?.softSurface
            : colors.safetyPlan.cardSecondaryBackground,
        minHeight: 52,
        maxWidth: "100%",
        boxSizing: "border-box",
      })}
    >
      <FontAwesomeIcon
        icon={icon}
        style={{ color: toneColor, fontSize: 14, flexShrink: 0 }}
      />
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 600,
          lineHeight: "20px",
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          minWidth: 0,
          color: toneColor,
        }}
      >
        {changeAmount} {message}
      </Typography>
    </Stack>
  )
}
